import Vue from 'vue'

// --- CONTROLE DE VERSÃO E CACHE ---
const APP_VERSION = '1.0.8'; // Incremente esta versão sempre que subir uma atualização importante
if (localStorage.getItem('app_version') !== APP_VERSION) {
  localStorage.clear();
  sessionStorage.clear();
  localStorage.setItem('app_version', APP_VERSION);
  // O reload força o navegador a buscar os arquivos mais recentes do servidor
  if (window.location.hash !== '#/login') {
    window.location.reload(true);
  }
}
// ----------------------------------
import App from './App.vue'
import { io } from 'socket.io-client'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import './assets/css/global.css';
// import './assets/css/tailwind.css';

import diVueMask from 'di-vue-mask';
import './plugins/axios';
import './plugins/print';
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'

Vue.config.productionTip = false

const globalLayoutFix = document.createElement('style')
globalLayoutFix.setAttribute('data-global-layout-fix', 'true')
globalLayoutFix.innerHTML = `
  html,
  body,
  #app,
  .v-application,
  .v-application--wrap,
  .v-main,
  .v-main__wrap {
    width: 100vw !important;
    min-width: 100vw !important;
    min-height: 100vh !important;
    margin: 0 !important;
    padding: 0 !important;
    background-color: #f8fafc !important;
  }

  body {
    overflow-x: hidden !important;
  }

  .v-application,
  .v-main,
  .v-main__wrap {
    background-color: #f8fafc !important;
  }
`
document.head.appendChild(globalLayoutFix)
document.documentElement.style.backgroundColor = '#f8fafc'
document.body.style.backgroundColor = '#f8fafc'
document.body.style.margin = '0'
document.body.style.overflowX = 'hidden'

Vue.use(Chartkick.use(Chart))
Vue.use(diVueMask)

if (process.env.NODE_ENV !== "production") {
  store.state.urlImages = "http://localhost:3010/uploads/";
}

const vueApp = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

vueApp.$store.state.appVersion = APP_VERSION;

// --- WEBSOCKET REALTIME SETUP ---
const socketUrl = process.env.NODE_ENV === "production"
  ? "https://api.sigfrotagov.com.br"
  : "http://localhost:3010";

const socket = io(socketUrl, {
  autoConnect: true,
  transports: ["websocket", "polling"],
});

Vue.prototype.$socket = socket;

socket.on("connect", () => {
  console.log("[Socket.io] Connected to server:", socket.id);
});

socket.on("supply_updated", () => {
  console.log("[Socket.io] supply_updated received, emitting to root event bus");
  vueApp.$root.$emit("supply_updated");
});
// ---------------------------------
